import { render } from "./AppLogoBadge.vue?vue&type=template&id=57c8fc84&scoped=true"
import script from "./AppLogoBadge.vue?vue&type=script&lang=js"
export * from "./AppLogoBadge.vue?vue&type=script&lang=js"

import "./AppLogoBadge.vue?vue&type=style&index=0&id=57c8fc84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c8fc84"]])

export default __exports__